import { atom } from 'jotai';

export type BackgroundJobType = 'sop_generation';

export interface BackgroundJob {
  jobId: string;
  jobType: BackgroundJobType;
  label: string;
  sopId?: string;
  sopCatId?: string;
  startedAt: number;
}

export const backgroundJobsAtom = atom<Map<string, BackgroundJob>>(new Map());

export const addBackgroundJobAtom = atom(null, (get, set, job: BackgroundJob) => {
  const current = new Map(get(backgroundJobsAtom));
  current.set(job.jobId, job);
  set(backgroundJobsAtom, current);
});

export const removeBackgroundJobAtom = atom(null, (get, set, jobId: string) => {
  const current = new Map(get(backgroundJobsAtom));
  current.delete(jobId);
  set(backgroundJobsAtom, current);
});
